import { defineRouting } from "next-intl/routing";

/**
 * Locale routing configuration for the operator UI.
 *
 * Locale name format MUST match what
 * ``apps/worker/src/vc_worker/workflows/_lang.py:normalize_lang()`` returns
 * (BCP-47 with hyphen, not the bare language code). Frontend's ``X-Locale``
 * header → backend workflow ``lang`` payload field travels through this
 * shape on both ends.
 *
 * Adding a locale is a 4-step change:
 *   1. Add the BCP-47 tag here.
 *   2. Add ``i18n/messages/<tag>.json`` (deep-merge fallback to ``en.json``
 *      is automatic — see ``request.ts``).
 *   3. Add the locale option to ``components/chrome/LocalePicker.tsx``.
 *   4. (If needed) Add a CSS font cascade for the script under
 *      ``styles/tokens.css`` — already done for ``[lang^="zh"]``.
 *
 * ``localePrefix: "always"`` means every URL carries its locale (``/en/...``
 * or ``/zh-CN/...``). Unprefixed deep links auto-307 to ``defaultLocale``.
 * Deferred: ``zh-TW`` (Traditional Chinese).
 */
export const routing = defineRouting({
  locales: ["en", "zh-CN"],
  defaultLocale: "en",
  localePrefix: "always",
});

export type Locale = (typeof routing.locales)[number];
